import React, { useEffect, useState } from "react"

import Breadcrumbs from "../../../components/Common/Breadcrumb"
import { useDispatch, useSelector } from "react-redux"
import MonitorInventoryListComponent from "components/MonitorReports/Inventory"
import {
  getMonitorIps,
  getMonitorItemCategories,
  getMonitorItems,
  getMonitorStock,
} from "store/monitor-dashboard/monitor-dashboard-action"
import { exportMonitorInventoryReport } from "store/monitor-reports/monitor-report-action"
import useReportColumns from "hooks/useReportColumns"
import { REPORT_COLUMN_KEYS } from "config/reportColumnDefinitions"

const MonitorInventoryList = props => {
  //meta title
  document.title = "Dashboard"

  const [params, setParams] = useState({})
  const [filters, setFilters] = useState(null)
  const { columns, visibleColumns, visibleKeys, toggleColumn, moveColumnToIndex } = useReportColumns(
    REPORT_COLUMN_KEYS.MONITOR_INVENTORY
  )
  const monitorStock = useSelector(state => state.monitorDashboard.monitorStock)

  const dispatch = useDispatch()

  // get new params and dispatch getMonitorStock action
  const onSubmit = values => {
    setParams(values)
    dispatch(getMonitorStock(values))
  }

  // Trigger export process when Export button is clicked
  const onExport = () => {
    dispatch(exportMonitorInventoryReport(filters, visibleKeys))
  }

  // Callback function to toggle the advanced search filter visibility when the button is clicked
  const onAdvancedSearchHandler = filters => {
    setFilters(filters)
  }

  // fetch new items based category changes
  const onCategoryChange = category => {
    dispatch(getMonitorItems(category))
  }

  // fetch monitor inventory and other data based filter needs
  useEffect(() => {
    dispatch(getMonitorStock())
    dispatch(getMonitorIps())
    dispatch(getMonitorItemCategories())
  }, [])

  return (
    <React.Fragment>
      <Breadcrumbs title={"Monitor"} breadcrumbItem={"Inventory"} />
      {/* Monitor Inventory list Component  */}
      <MonitorInventoryListComponent
        provStock={monitorStock?.data?.data?.monitorReports}
        provData={monitorStock?.data?.data}
        onSubmit={onSubmit}
        onCategoryChange={onCategoryChange}
        onExport={onExport}
        onAdvancedSearchHandler={onAdvancedSearchHandler}
        columns={columns}
        visibleColumns={visibleColumns}
        onToggleColumn={toggleColumn}
        onReorder={moveColumnToIndex}
      />
    </React.Fragment>
  )
}

export default MonitorInventoryList
